import { type Info } from '@core-frontend/core-frontend';

import { baseClient } from '@/shared/api/baseClient';

export const getUserInfo = async () => {
  const response = await baseClient.get<Info>('/user-roles/me/info');
  return response.data;
};
